import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Translate, injectIntl } from "../../localization/index";
import { MOLink, IKeywordShortcode } from "ouisys-clients/dist/clients/common-components/MOLink";
import HOC, {initialState, HOCProps, MSISDNEntrySuccess, match } from "ouisys-clients/dist/clients/tallyman.v1-pin/HOC";
import { backToStart } from "ouisys-engine/dist/reducers/ussdFlow";
import {tracker} from "ouisys-engine/dist/reducers/strategy"
import Loader from "../Loader";

const USSD = ({ keyword, shortcode }: IKeywordShortcode)=>{
    const dispatch = useDispatch();
 
    return (
        
        <div className="">
            <Loader/>
            
            <a className="tryAgainLink"
                onClick={() => {
                    dispatch(backToStart());
                    tracker.recedeInFlow("tallyman.v1-pin", "MSISDN_ENTRY", "requested to change phone number")
                  }}
                  >
                <Translate id="tryAgainLabel" defaultMessage="Try again" /></a>
            
      </div>
    )
};

export default injectIntl(USSD);